import { authClient } from "@/lib/auth-client";

export function verifyPhoneOtp(input: {
  phoneNumber: string;
  code: string;
  mode: "signin" | "signup" | "link";
  language: string;
  currency: string;
}) {
  if (input.mode === "signup") {
    return authClient.phoneNumber.verify({
      phoneNumber: input.phoneNumber,
      code: input.code,
      updatePhoneNumber: false,
      language: input.language,
      currency: input.currency,
    });
  }

  return authClient.phoneNumber.verify({
    phoneNumber: input.phoneNumber,
    code: input.code,
    updatePhoneNumber: input.mode === "link",
  });
}
